const Bullet = ({ backgroundColor, className, color, imgSrc, title = "" }) => {
  return (
    <div
      className={`absolute ${className} text-center flex justify-center items-center flex-col`}
    >
      <div
        style={{ backgroundColor }}
        className="shadow-md h-12 w-12 rounded-lg p-2 "
      >
        {imgSrc && <img alt={title} className="w-8 h-8 m-auto" src={imgSrc} />}
      </div>
      <p
        style={{ color }}
        className="font-medium body-14px-medium mt-2"
      >
        {title}
      </p>
    </div>
  );
};

export default Bullet;
